import {
  collection, getDocs, query, where, orderBy,
} from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { DRXError } from '@/lib/drx-error';
import type { IPaymentRepository, GetPaymentData } from './interfaces/payment.repository.interface';

export class PaymentRepository implements IPaymentRepository {
  private collectionName = 'payments';

  async getUserPayments(userId: string): Promise<GetPaymentData[]> {
    try {
      const q = query(
        collection(db, this.collectionName),
        where('userId', '==', userId),
        orderBy('createdAt', 'desc'),
      );
      const snapshot = await getDocs(q);
      return snapshot.docs.map(d => ({ id: d.id, ...d.data() } as GetPaymentData));
    } catch (error) {
      throw new DRXError({
        code: 'PAYMENT_FETCH_FAILED',
        devMessage: `Failed to fetch payments for user ${userId}`,
        cause: error,
      });
    }
  }
}
